<template>
  <div class="eventos-participantes-importacion">
    <b-card no-header>
      <b-row>
        <b-col>
          <b-form>
            <b-form-group
                description="Listado de participantes en formato csv">
              <b-form-file 
                v-model="file" 
                class="mt-3" 
                accept=".csv" 
                placeholder="Seleccione un archivo o arrastrelo hasta aquí">
              </b-form-file>
            </b-form-group>
          </b-form>
          <div slot="footer">
            <b-button size="sm" variant="primary" class="footer-button"
              @click.prevent="importar">Importar</b-button>
            <b-button size="sm" variant="danger" class="footer-button"
              @click.prevent="cancelar">Cancelar</b-button>
          </div>
        </b-col>
      </b-row>
    </b-card>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>

    <app-confirm
      :confirmModalVisible="confirmModalVisible"
      :confirmMsj="confirmMsj"
      :confirmOkTitle="confirmOkTitle"
      :confirmCancelTitle="confirmCancelTitle"
      @confirmOk="confirmOk"
      @confirmCancel="confirmCancel">
    </app-confirm>
  </div>
</template>

<script>
import Mensaje from  '../shared/msjModal.vue';
import Confirm from  '../shared/confirmModal.vue';
import { msjModal, confirmModal } from '../../mixins/modalDialogs'

export default {
  name: 'ParticipantesImportacionSorteo',
  components: {
    appMensaje: Mensaje,
    appConfirm: Confirm
  },
  mixins: [ 
    msjModal, 
    confirmModal
  ],
  data: () => {
    return {
      file: null,
    }
  },
  computed: {
  },
  created() {
  },  
  methods: {
    cancelar() {
      let params = {
        actualizado: false,
      }
      this.close(params);
    },
    close(params) {
      this.$emit('close', params);
    },
    importar() {
      if (this.file) {
        this.showSpinner();

        let params = {
          file: this.file
        }

        this.$store.dispatch('participantesSorteo/importarParticipantes', params)
          .then( () => {
            return {
              actualizado: true,
            };
          })
          .then(params => this.close(params))
          .catch( error => this.showErrorMsj (error))
          .finally(() => this.hideSpinner());
      }
    },
  },
  watch: {
  }   
}
</script>

<style>

  .evento-codigos-promocion-importacion .custom-file-input ~ .custom-file-label[data-browse]::after {
    content: 'Buscar' !important;
  }

  .evento-codigos-promocion-importacion .b-form-file {
    position: relative;
    display: inline-block;
    width: calc(100% - 50px);
  }

  .evento-codigos-promocion-importacion .filter-search-icons {
    position: relative;
    display: inline-block;
    margin-left: 5px;
    margin-top: 6px;
    /* margin-top: 16px; */
    /* width: calc(100% - 50px); */
  }
  .evento-codigos-promocion-importacion .filter-search-icons div {
    height: 34px;
  }
</style>